import React from "react";

const RechargeProcess = () => {
  return (
    <section id="process" style={{ padding: "60px 0", background: "#f8fafc" }}>
      <div className="container">
        <h2 className="section-title">Recharge in 4 Simple Steps</h2>
        <p className="section-sub">
          Get started in minutes and complete your recharge securely.
        </p>

        <div className="process-steps">
          <div className="step-card">
            <div className="step-number">1</div>
            <h4>Create Account</h4>
            <p>
              Sign up with your mobile number and email in just a few clicks.
            </p>
          </div>

          <div className="step-card">
            <div className="step-number">2</div>
            <h4>Select a Service</h4>
            <p>Choose Mobile, DTH, Utility Bills, or any available service.</p>
          </div>

          <div className="step-card">
            <div className="step-number">3</div>
            <h4>Make Payment</h4>
            <p>Pay securely using UPI.</p>
          </div>

          <div className="step-card">
            <div className="step-number">4</div>
            <h4>Instant Confirmation</h4>
            <p>
              Receive instant confirmation and view your transaction history.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RechargeProcess;
